"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasErrors = exports.Checked = exports.Status = void 0;
exports.Status = {
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error',
};
const Checked = class {
    constructor(tag, status, message) {
        this.tag = tag;
        this.status = status;
        this.message = message;
    }
};
exports.Checked = Checked;
const hasErrors = (checked) => {
    function isError(chk) {
        return chk.status === exports.Status.ERROR;
    }
    return checked.filter((chk) => isError(chk)).length > 0;
};
exports.hasErrors = hasErrors;
